// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/download-integration-call-report-request-schema',
  type: 'object',
  required: [],
  properties: {
    dateFrom: {
      type: 'string',
      format: 'date-time',
    },
    dateTo: {
      type: 'string',
      format: 'date-time',
    },
    customerName: {
      type: 'string',
    },
    taskId: {
      type: 'integer',
    },
    integrationStatusId: {
      type: 'integer',
    },
    searchCriteria: {
      type: 'string',
    },
  },
} as IJSONSchema;

export default schema;
